import React, { useEffect, useState } from 'react'
import './Statistics.scss'
import { Graph } from '../../../../../Assets/Icons'
import loanService from 'Services/loanServices'
import { Logger } from 'Helpers/Logger'
import statsService from 'Services/statsService'
import { useParams } from 'react-router-dom'
import employeeService from 'Services/employeeService'
import { EmployeeType } from 'Models'
import { countryType } from '../../User/EditUserPlan/EditUserPlan'
import Swal from 'sweetalert2'
import { leaveService } from 'Services/leaveService'

interface balanceType {
  loanProvide: string
  totalLoanDisbursedMajor: number
  portfolioAmountMajor: number
  cycleCount: number
}

const Statistics = () => {
  const [loading, setLoading] = useState(false)

  const [paginationData, setPaginationData] = useState<{
    pageNumber: number
    pageSize: number
    total: number
  }>({
    pageNumber: 1,
    pageSize: 20,
    total: 1,
  })

  const getUsers = async () => {
    setLoading(true)
    await employeeService.index(1, 'DESC').then(
      (response) => {
        console.log('employeeService', response?.data)
        setLoading(false)

        const dataSet = response?.data.data.dataset

        setPaginationData({
          pageNumber: response?.data.data.pageNumber,
          pageSize: response?.data.data.pageSize,
          total: response?.data.data.total,
        })
      },
      (error: { response: { data: { error: string } } }) => {
        setLoading(false)
      },
    )
  }

  useEffect(() => {
    getUsers()
  }, [])

  const [paginationData2, setPaginationData2] = useState<{
    pageNumber: number
    pageSize: number
    total: number
  }>({
    pageNumber: 1,
    pageSize: 20,
    total: 1,
  })

  const getLoan = async () => {
    setLoading(true)
    await loanService.getAll(1).then(
      (response: { data: { data: { pageNumber: any; pageSize: any; total: any } } }) => {
        setLoading(false)
        console.log('response', response)

        setPaginationData2({
          pageNumber: response?.data.data.pageNumber,
          pageSize: response?.data.data.pageSize,
          total: response?.data.data.total,
        })
      },
      (error: { response: object }) => {
        setLoading(false)
        Logger('response error', error.response)
      },
    )
  }

  useEffect(() => {
    getLoan()
  }, [])

  const [paginationData3, setPaginationData3] = useState<{
    pageNumber: number
    pageSize: number
    total: number
  }>({
    pageNumber: 1,
    pageSize: 20,
    total: 1,
  })

  const getLeave = async () => {
    await leaveService.getAdminLeave(1).then(
      (data) => {
        console.log(data.data.data.dataset)
        setPaginationData3({
          pageNumber: data?.data.data.pageNumber,
          pageSize: data?.data.data.pageSize,
          total: data?.data.data.total,
        })
      },
      (error: { response: { data: { error: string } } }) => {
        console.log('leaveService', error)
        Swal.fire({
          icon: 'warning',
          title: 'Oops!',
          text: error.response.data.error,
          showConfirmButton: false,
          timer: 3000,
        })
      },
    )
  }

  useEffect(() => {
    getLeave()
  }, [])

  return (
    <div className='statistics'>
      <div className='container'>
        <div className='row mt-4'>
          <div className='col-12 col-md-6 col-lg-4'>
            <div className='card border-0'>
              <div className='card-body'>
                <div className='row'>
                  <div className='col-8 title'>Employees</div>
                  <div className='col-4 subtitle d-none'>All time total</div>
                  <div className='col-7'>
                    <div className='col-12 value'>
                      {loading === false ? (
                        paginationData.total
                      ) : (
                        <span className='spinner-border spinner-border-sm'></span>
                      )}
                    </div>

                    <div className='col-12 d-none'>
                      <span className='bottom-percent'>
                        <svg
                          width='18'
                          height='19'
                          viewBox='0 0 18 19'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M14.0099 10.9851L11.6024 8.57755L10.1324 7.10005C9.50993 6.47755 8.49743 6.47755 7.87493 7.10005L3.98993 10.9851C3.47993 11.4951 3.84743 12.3651 4.55993 12.3651H8.76743H13.4399C14.1599 12.3651 14.5199 11.4951 14.0099 10.9851Z'
                            fill='#6CC91A'
                          />
                        </svg>{' '}
                        5%
                      </span>
                      <span className='bottom-week ms-4'>+5M this week</span>
                    </div>
                  </div>
                  <div className='col-5 graph d-none'>
                    <Graph></Graph>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-12 col-md-6 col-lg-4'>
            <div className='card border-0'>
              <div className='card-body'>
                <div className='row'>
                  <div className='col-8 title'>Loan Applications</div>
                  <div className='col-4 subtitle d-none'>All time total</div>
                  <div className='col-7'>
                    <div className='col-12 value'>
                      {loading === false ? (
                        paginationData2.total
                      ) : (
                        <span className='spinner-border spinner-border-sm'></span>
                      )}
                    </div>

                    <div className='col-12 d-none'>
                      <span className='bottom-percent text-danger'>
                        <svg
                          width='18'
                          height='19'
                          viewBox='0 0 18 19'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M14.0099 8.01495L11.6024 10.4224L10.1324 11.8999C9.50993 12.5224 8.49743 12.5224 7.87493 11.8999L3.98993 8.01495C3.47993 7.50495 3.84743 6.63495 4.55993 6.63495H8.76743H13.4399C14.1599 6.63495 14.5199 7.50495 14.0099 8.01495Z'
                            fill='#EB2222'
                          />
                        </svg>
                        1%
                      </span>
                      <span className='bottom-week ms-4'>-1k this month</span>
                    </div>
                  </div>
                  <div className='col-5 graph  d-none'>
                    <Graph></Graph>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-12 col-md-6 col-lg-4'>
            <div className='card border-0'>
              <div className='card-body'>
                <div className='row'>
                  <div className='col-8 title'>Leave Applications</div>
                  <div className='col-4 subtitle d-none'>This month</div>
                  <div className='col-7'>
                    <div className='col-12 value'>
                      {loading === false ? (
                        paginationData3.total
                      ) : (
                        <span className='spinner-border spinner-border-sm'></span>
                      )}
                    </div>

                    <div className='col-12 d-none'>
                      <span className='bottom-percent'>
                        <svg
                          width='18'
                          height='19'
                          viewBox='0 0 18 19'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M14.0099 10.9851L11.6024 8.57755L10.1324 7.10005C9.50993 6.47755 8.49743 6.47755 7.87493 7.10005L3.98993 10.9851C3.47993 11.4951 3.84743 12.3651 4.55993 12.3651H8.76743H13.4399C14.1599 12.3651 14.5199 11.4951 14.0099 10.9851Z'
                            fill='#6CC91A'
                          />
                        </svg>
                        5%
                      </span>
                      <span className='bottom-week ms-4'>+5M this week</span>
                    </div>
                  </div>
                  <div className='col-5 graph d-none'>
                    <Graph></Graph>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Statistics
